const vuetifyRouter = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout"),
    children: [
      {
        path: "/vuetify",
        name: "vuetify",
        component: () => import("@/view/vuetify/Vuetify.vue"),
        children: [
          {
            path: "alerts",
            name: "vuetify-alerts",
            component: () => import("@/view/vuetify/Alerts.vue"),
          },
          {
            path: "avatars",
            name: "vuetify-avatars",
            component: () => import("@/view/vuetify/Avatars.vue"),
          },
          {
            path: "badges",
            name: "vuetify-badges",
            component: () => import("@/view/vuetify/Badges.vue"),
          },
          {
            path: "buttons",
            name: "vuetify-buttons",
            component: () => import("@/view/vuetify/Buttons.vue"),
          },
          {
            path: "calendars",
            name: "vuetify-calendars",
            component: () => import("@/view/vuetify/Calendars.vue"),
          },
          {
            path: "cards",
            name: "vuetify-cards",
            component: () => import("@/view/vuetify/Cards.vue"),
          },
          {
            path: "chips",
            name: "vuetify-chips",
            component: () => import("@/view/vuetify/Chips.vue"),
          },
          {
            path: "dialog",
            name: "vuetify-dialog",
            component: () => import("@/view/vuetify/Dialog.vue"),
          },
          {
            path: "forms-autocompletes",
            name: "vuetify-autocompletes",
            component: () =>
              import("@/view/vuetify/forms/Autocompletes.vue"),
          },
          {
            path: "forms-file-inputs",
            name: "vuetify-file-inputs",
            component: () =>
              import("@/view/vuetify/forms/FileInputs.vue"),
          },
          {
            path: "forms",
            name: "vuetify-forms",
            component: () => import("@/view/vuetify/forms/Forms.vue"),
          },
          {
            path: "forms-selection-controls",
            name: "vuetify-selection-controls",
            component: () =>
              import("@/view/vuetify/forms/SelectionControls.vue"),
          },
          {
            path: "forms-selects",
            name: "vuetify-selects",
            component: () => import("@/view/vuetify/forms/Selects.vue"),
          },
          {
            path: "forms-textareas",
            name: "vuetify-textareas",
            component: () =>
              import("@/view/vuetify/forms/Textareas.vue"),
          },
          {
            path: "forms-text-fields",
            name: "vuetify-text-fields",
            component: () =>
              import("@/view/vuetify/forms/TextFields.vue"),
          },
          {
            path: "tables-simple-tables",
            name: "vuetify-simple-tables",
            component: () =>
              import("@/view/vuetify/tables/SimpleTables.vue"),
          },
          {
            path: "tables-data-tables",
            name: "vuetify-data-tables",
            component: () =>
              import("@/view/vuetify/tables/DataTables.vue"),
          },
          {
            path: "tabs",
            name: "vuetify-tabs",
            component: () => import("@/view/vuetify/Tabs.vue"),
          },
          {
            path: "timelines",
            name: "vuetify-timelines",
            component: () => import("@/view/vuetify/Timelines.vue"),
          },
          {
            path: "tooltips",
            name: "vuetify-tooltips",
            component: () => import("@/view/vuetify/Tooltips.vue"),
          },
          {
            path: "treeview",
            name: "vuetify-treeview",
            component: () => import("@/view/vuetify/Treeview.vue"),
          },
        ],
      }
    ],
  }
]

export default vuetifyRouter;